





















































import Vue from "vue";
import { mapState, mapMutations } from 'vuex'
import StartScreen from './components/StartScreen.vue'
import SliderBlock from './components/SliderBlock.vue'
import { slides } from './content/slider'
import { TweenMax } from 'gsap'
import SliderMobile from "./components/SliderMobile.vue";
import MobileStartScreen from "./components/MobileStartScreen.vue";
import Gallery from "./components/Gallery.vue";
import stickybits from 'stickybits';
import AsideBlock from "./components/AsideBlock.vue";
import Button from "./components/common/Button.vue";
import Header from "./components/Header.vue";
import AsideMobile from "./components/AsideMobile.vue";
import FullscreenPopup from "./components/FullscreenPopup.vue"


export default Vue.extend({
  name: 'App',
  metaInfo: {
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover' }
    ]
  },
  data() {
    return {
      videoMuted: true,
      bundler: "Parcel",
      animationGoing: false,
      videoOpened: false,
      videoIsPlaying: false,
    };
  },
  components: {
    StartScreen,
    SliderBlock,
    SliderMobile,
    Gallery,
    AsideBlock,
    Button,
    Header,
    MobileStartScreen,
    AsideMobile,
    FullscreenPopup
  },
  computed: {
    ...mapState(['slideNumber', 'showGallery', 'windowWidth','videoPopupOpened']),
    slides() {
      return slides
    },
    isMobile() {
      return this.windowWidth < 1000
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    // if (!location.href.includes('modal=callback')) {
    //   let checkIfPopupOpened = setInterval(() => {
    //     console.log('!!!!!!!!!!!!!!')
    //     if (location.href.includes('modal=callback')) {
    //       window.location.reload(true)
    //       document.body.classList.remove('_mobile-resize')
    //       clearInterval(checkIfPopupOpened)
    //     }
    //   }, 100)
    // }
    
  },
  watch: {
    animationGoing() {
      this.animationGoing
    },
  },
  methods: {
    ...mapMutations(['nextSlide', 'prevSlide', 'setWindowWidth', 'toggleGallery', 'setGalleryEntranceFromSlider']),
    toggleAudio() {
      if (!this.$refs.video) return
      this.videoMuted = !this.videoMuted;
    },
    handleResize() {
      this.setWindowWidth(window.innerWidth)
    },
    closeVideo() {
      this.videoOpened = false
    },
    changeSlide(evt, direction) {
      if (this.isMobile || this.showGallery || this.videoPopupOpened) return
      if (this.slideNumber === 6 && (direction === 'next' || evt.deltaY > 0)) {
        this.toggleGallery();
        this.setGalleryEntranceFromSlider();
        return
      }
      if (evt.deltaY > 0 || direction === 'next') {
        if (this.slideNumber === slides.length && !this.animationGoing) {
          this.nextSlide()
        } 
        if (this.slideNumber < slides.length && !this.animationGoing && this.slideNumber > 0){
          this.animationGoing = true
          this.nextSlide()
          TweenMax.to(this.$refs.slidesContainer, 1, {x: `-${(this.slideNumber - 1) * 100/(slides.length) + 0.000001}%`, onComplete: () => {console.log('AAAAA'); this.animationGoing = false}})
        }
        if (this.slideNumber === 0) {
          this.animationGoing = true;
          this.nextSlide()           
          setTimeout(() => {
            this.animationGoing = false;
          }, 1000);
            
            
        } 
        
      } else if (evt.deltaY < 0 || direction === 'prev') {
        if (this.slideNumber > 1 && !this.animationGoing){
          this.animationGoing = true;
          this.prevSlide();
          TweenMax.to(this.$refs.slidesContainer, 1, {x: `-${(this.slideNumber - 1) * 100/(slides.length) + 0.000001}%`, onComplete: () => {this.animationGoing = false}})
        } 
        if (this.slideNumber === 1 && !this.animationGoing) {
          this.prevSlide();
        }
      }
    },
    sticky() {
      stickybits('.aside-block__mobile', {useFixed: true})
    },
    toggleVideoPlay() {
      if (this.videoIsPlaying) {
        this.$refs.video.pause();
        this.videoIsPlaying = false;
        return
      } else if ( this.$refs.video) {
        this.$refs.video.play();
        this.videoIsPlaying = true;
        return
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.updateWidth);
    this.sticky()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
});
